/**============================================================
* [observerShowObj]
* description : observerで表示するオブジェクト
* 引数（target:コントロールする要素, ex:過ぎたら表示する要素）
============================================================*/
export default class observerShowObj {
  constructor(
    target,
    ex = document.querySelector('.l-page-header')
  ) {
    this.headerH = document.getElementById('header-navigation').offsetHeight;
    this.footer = document.getElementById('footerNavigation');
    this.exclude = ex;
    this.target = target;

    //表示タイミング（デフォルトはページヘッダーが過ぎた時）
    const handleObserveStart = (elems) => {
      elems.forEach((elem) => {
        if (elem.isIntersecting) {
          this.target.classList.remove('is-show');
        }else{
          this.target.classList.add('is-show');
        }
      });
    }
    const observerOptionsStart = {
      root: null,
      rootMargin: `-${this.headerH}px 0px 0px 0px`,
      threshold: 0
    };
    const observerStart = new IntersectionObserver(handleObserveStart, observerOptionsStart);

    //非表示タイミング（footer）
    const handleObserveEnd= (elems) => {
      elems.forEach((elem) => {
        if (elem.isIntersecting) {
          this.target.classList.add('is-footer-show');
        }else{
          this.target.classList.remove('is-footer-show');
        }
      });
    }
    const observerOptionsEnd = {
      root: null,
      rootMargin: '0px 0px -30% 0px',
      threshold: 0
    };
    const observerEnd = new IntersectionObserver(handleObserveEnd, observerOptionsEnd);

    if(this.exclude){
      observerStart.observe(this.exclude);
    }else{
      this.target.classList.add('is-show');
    }
    observerEnd.observe(this.footer);
  }
}
